<template>
  <div id="app">
    <Navbar />

    <div class="section" id="section1">
      <div class="logo-container">
        <div class="circles-top">
          <div class="circle">
            <router-link to="/centres-d-interet">
              <el-icon :size="26" class="circle-icon"><Reading /></el-icon>
              <span>Centres d'intérêt</span>
            </router-link>
          </div>
          <div class="circle">
            <router-link to="/club-des-chippies">
              <el-icon :size="26" class="circle-icon"><ChatLineRound /></el-icon>
              <span>Club des chipies</span>
            </router-link>
          </div>
          <div class="circle">
            <p v-if="isLoggedIn" @click="viewUserProfile(username)">
              <el-icon :size="26" class="circle-icon"><User /></el-icon>
              <span>Page membre</span>
            </p>
            <router-link v-if="!isLoggedIn" to="/register">
              <el-icon :size="26" class="circle-icon"><User /></el-icon>
              <span>Page membre</span>
            </router-link>
          </div>
          <div class="circle">
            <router-link to="/groupes-entraide">
              <el-icon :size="26" class="circle-icon"><Connection /></el-icon>
              <span>Groupes d'entraide</span>
            </router-link>
          </div>
        </div>
        <img :src="require('@/assets/logo_wedoo.png')" alt="Wedoo Logo" class="main-logo">
        <div class="circles-bottom">
          <div v-for="rubrique in comingSoonRubriques" :key="rubrique.path" class="circle">
            <router-link :to="rubrique.path">
              <el-icon :size="26" class="circle-icon"><component :is="rubrique.icon" /></el-icon>
              <span>{{ rubrique.label }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="section" id="section2">
      <p>
        Bienvenue !
        <br><br>
        Nous avons envie de créer un réseau basé sur les valeurs associatives : entraide, solidarité, partage et responsabilité mutuelle.
        <br><br>
        Nous y travaillons depuis longtemps. Après l'élaboration, nous en sommes à l'étape de construction.
        <br><br>
        Nous avons besoin de votre engagement pour solidifier cette construction. Rejoignez-nous !
        <br><br>
        À très bientôt.
        <br><br>
        <a href="mailto:wedoomotiondeveloppement@gmail.com" class="contact-link">wedoomotiondeveloppement@gmail.com</a>
      </p>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import api from '@/api';
import { markRaw } from 'vue'
import { Reading, ChatLineRound, User, Connection, Clock, List, Sunny } from '@element-plus/icons-vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Reading,
    ChatLineRound,
    User,
    Connection,
  },

  data() {
    return {
      username: null,
      isLoggedIn: false,
      // Rubriques en préparation : chacune mène à sa page « bientôt » (voir router/index.js)
      comingSoonRubriques: [
        { path: '/a-venir', label: 'À venir', icon: markRaw(Clock) },
        { path: '/questionnaires', label: 'Questionnaires', icon: markRaw(List) },
        { path: '/notre-volonte', label: 'Notre volonté', icon: markRaw(Sunny) },
      ],
    }
  },

  mounted() {
    // La balise est mémorisée pour être retirée au démontage (sinon elle s'accumule dans <head>)
    this.styleTag = document.createElement('style')
    this.styleTag.textContent = 'body { margin: 0; }'
    document.head.appendChild(this.styleTag)
    this.loadUserId()
  },
  beforeUnmount() {
    if (this.styleTag) this.styleTag.remove()
  },

  methods: {
    async loadUserId() {
      try {
        const response = await api.get('/session/me', { withCredentials: true })
        if (response.status === 200) {
          this.username = response.data.username
          this.isLoggedIn = true
        } else {
          console.error('Invalid session')
          this.isLoggedIn = false
        }
      } catch (error) {
        console.error('Error checking session:', error)
        this.isLoggedIn = false
      }
    },

    viewUserProfile(username) {
      this.$router.push({ name: 'UserProfile', params: { username: username } })
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
}

body {
  background-color: rgba(21, 109, 123);
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 200vh;
}

.section {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

#section1 {
  background-color: rgba(21, 109, 123);
  margin: 0;
  padding-top: 60px;
}

#section2 {
  background-color: rgb(68, 122, 131);
  margin: 0;
  color: white;
  padding: 0 20px;
}

.contact-link {
  color: white;
  text-decoration: underline;
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.main-logo {
  width: 75%;
  max-width: 500px;
}

.circles-top,
.circles-bottom {
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
  margin: 30px 0;
}

.circle {
  width: 100px;
  height: 100px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8px;
  box-sizing: border-box;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.circle:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.circle a,
.circle p {
  color: #303133;
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.circle-icon {
  color: #156d7b;
}
</style>
